class ComponentBlogSwiper extends HHBaseElement {
  get swiperEl() {
    return this.querySelector('swiper-container')
  }

  get gutter() {
    return window.innerWidth <= 767 ? 25 : 60
  }

  get swiperParams() {
    return {
      slidesPerView: 'auto',
      navigation: true,
      slidesOffsetBefore: this.gutter,
      spaceBetween: 25,
      slidesOffsetAfter: this.gutter,
      injectStyles: [
        `
          .swiper-button-prev.swiper-button-disabled,
          .swiper-button-next.swiper-button-disabled {
            opacity: 0;
          }
      `,
      ],
    }
  }

  connectedCallback() {
    if (this.swiperEl) {
      Object.assign(this.swiperEl, this.swiperParams)
      this.swiperEl.initialize()
    }
  }
}

window.customElements.define('component-blog-swiper', ComponentBlogSwiper)
